/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProvisioningNotificationSourceTypeEnum = 'FAST' | 'INCORTA' | 'CSP_V4' | 'LEGACY';

export const ProvisioningNotificationSourceTypeEnum = {

    FAST: 'FAST' as ProvisioningNotificationSourceTypeEnum,

    INCORTA: 'INCORTA' as ProvisioningNotificationSourceTypeEnum,

    CSP_V4: 'CSP_V4' as ProvisioningNotificationSourceTypeEnum,

    LEGACY: 'LEGACY' as ProvisioningNotificationSourceTypeEnum
};

